/**
 * MODULE: _shared/frontend-shell/src/components/brain/BrainRepContactPatternsHint.tsx
 * PURPOSE: Cross-surface footnote for rep activity rhythm from context/resolve [2.2.1246].
 * DEPENDENCIES: assistantContextApi types
 * PUBLIC_API: BrainRepContactPatternsHint
 * SIDE_EFFECTS: None
 * AGENT_SAFETY: SAFE
 * FILE_SIZE: 32 / 100 lines
 * RECENT: 2026-05-26 [2.2.1246] — Shared across assistant rail, CRM drawers, Pages brain panels.
 */

import type { AssistantRepContactPatterns } from '@shared/lib/frontend/api/assistantContextApi';

type Props = {
  patterns?: AssistantRepContactPatterns | null;
  testId?: string;
  className?: string;
};

export function BrainRepContactPatternsHint({
  patterns,
  testId = 'brain-rep-contact-patterns',
  className = '',
}: Props) {
  const summary = patterns?.summary?.trim();
  if (!summary) return null;
  return (
    <p
      className={`text-[10px] leading-relaxed text-slate-600 dark:text-slate-400 ${className}`}
      data-testid={testId}
    >
      Your activity rhythm: {summary}
    </p>
  );
}
